import React from 'react';
import { Link } from 'react-router-dom';
import Reactmarkdown from 'react-markdown';

const Document = ( {match, item} ) => (
	<div id="Document">
		<h1>{`Tietosuojaseloste - ${item.data.service.name}`}</h1>
		<p>EU:n yleinen tietosuoja-asetus (2016/679)<br/>13. ja 14. artikla</p>
		{item.text ?
		<div>
  		<Reactmarkdown source={item.text} escapeHtml={false} />

		<Link to={match.url+"/edit"} className="mdl-button mdl-button--raised mdl-button--accent">
			Edit
		</Link>
		</div> :
		<div className="spinner">
            <div className="rect1"></div>
            <div className="rect2"></div>
            <div className="rect3"></div>
            <div className="rect4"></div>
            <div className="rect5"></div>
         </div>}
	</div>
)

export default Document



// WEBPACK FOOTER //
// ./src/containers/document.js